export default __webpack_public_path__ + "static/media/construction-hammer.cdabd9bb.svg";